import { Type } from "class-transformer";
import { BaseContent, DataFrameContent } from "./BaseContent";
import { Content } from "./PortfolioResponse";

export class Interpretation {
  plaintext: string | undefined;
  tagged: string | undefined;
}

export class DetailedInterpretation {
  plaintext: string | undefined;
  tagged: string | undefined;
}

class InfoContent extends BaseContent {
  getSummaryAsTable(): {} {
    throw new Error("Method not implemented.");
  }
  input: string | undefined;
  @Type(() => Interpretation)
  interpretation: Interpretation | undefined;
  @Type(() => DetailedInterpretation)
  detailed_interpretation: DetailedInterpretation | undefined;
}

export class Pod {
  position: number | undefined;
  title: string | undefined;

  @Type(() => BaseContent, {
    discriminator: {
      property: "class",
      subTypes: [
        { value: Content, name: "Result:PortfolioAnalysis" },
        { value: DataFrameContent, name: "Result:DataFrame" },
        { value: InfoContent, name: "Input" },
      ],
    },
  })
  content: Content | InfoContent | DataFrameContent | undefined;

  @Type(() => Subpod)
  subpods: Subpod[] | undefined;

  getData() {
    return this.content;
  }
}

export class Data {
  exceptions: any[] | undefined;
  @Type(() => Pod)
  pods: Pod[] | undefined;

  getData() {
    if ((this.pods?.length ?? 0) > 1) {
      return this.pods![1].getData();
    }
  }
}

export class ResponseModel {
  success: boolean | undefined;
  @Type(() => Data)
  data: Data | undefined;

  getData() {
    if (this.success) {
      return this.data?.getData();
    }
  }
}

export class SubPodContent {
  data: string[] | undefined;
}

export class Subpod {
  class: string | undefined;
  position: number | undefined;
  title: string | undefined;
  @Type(() => SubPodContent)
  content: SubPodContent | undefined;
  subpods: any[] | undefined;
}
export class Profile {
  compile: number | undefined;
  interpreter: number | undefined;
  pods: number | undefined;
  total: number | undefined;
}
